import { API_ENDPOINT } from "./Constants";

export async function fetcher(url, method, body, token) {
    const api_endpoint = API_ENDPOINT;

    const headers = {
        accept: "application/json",
        "content-type": "application/json",
    };

    if (token) {
        headers.authorization = `Bearer ${token}`;
    }
    const result = await fetch(api_endpoint + url, {
        method: method,
        headers: headers,
        body: body,
    });

    if (result.ok) {
        return await result.json();
    }

    throw { status: result.status, data: await result.json() };
}
export default fetcher;
